import React, { Component } from 'react';
import { Button, Modal, Form, Input } from 'antd';
import styles from './styles.module.scss';
import cw from '../../utils/commonwords';
import { FormattedMessage } from 'react-intl';

class GroupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible,
      data: {}
    };
  }
  componentWillReceiveProps = newProps => {
    this.setState((state, props) => ({
      visible: newProps.visible,
      data: newProps.data
    }));
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { userId, intl, siteLanguage } = this.props;
        this.props.onSubmit(values, userId, intl, siteLanguage);
      }
    });
  };

  render() {
    const {
      title,
      handleCloseModal,
      addingGroup,
      groupFormStatus,
      form: { getFieldDecorator },
      intl
    } = this.props;
    const { visible, data } = this.state;
    return (
      <Modal
        className={styles.modal}
        destroyOnClose={true}
        maskClosable={false}
        centered
        onCancel={handleCloseModal}
        visible={visible}
        title={title}
        footer={null}
        width={420}
      >
        <Form onSubmit={this.handleSubmit} hideRequiredMark>
          <Form.Item>
            {getFieldDecorator('name', {
              initialValue: data.name,
              validate: [
                {
                  trigger: 'onChange',
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(
                        cw.formErrorMsgProvideGroupName
                      )
                    }
                  ]
                },
                {
                  rules: [
                    {
                      max: 15,
                      message: intl.formatMessage(
                        cw.formErrorMsgNotExceedFifteen
                      )
                    }
                  ]
                },
                {
                  trigger: 'onSubmit',
                  rules: [
                    {
                      min: 2,
                      message: intl.formatMessage(
                        cw.formErrorMsgNotExceedTwo
                      )
                    }
                  ]
                }
              ]
            })(
              <Input
                autoFocus
                data-dfs-people-id={'group-name-input'}
                maxLength={15}
              />
            )}
          </Form.Item>
          {groupFormStatus === 'edit' && (
            <Form.Item>
              {getFieldDecorator('groupId', {
                initialValue: data['uuid'],
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(
                      cw.formErrorMsgGroupRequired
                    )
                  }
                ]
              })(<Input type="hidden" />)}
            </Form.Item>
          )}
          <div className={styles.btnGroup}>
            <div />
            <div>
              <Button
                type="link"
                onClick={handleCloseModal}
                style={{ marginRight: 8 }}
              >
                <FormattedMessage id="Cancel" defaultMessage={'Cancel'} />
              </Button>
              <Button loading={addingGroup} htmlType="submit" type="primary">
                {groupFormStatus === 'edit' ? (
                  <FormattedMessage id="App.save" defaultMessage={'Save'} />
                ) : (
                  <FormattedMessage
                    id="App.Form.formMsgCreategroup"
                    defaultMessage={'Create group'}
                  />
                )}
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    );
  }
}
GroupForm.defaultProps = {
  data: {
    name: ''
  }
};
const WrappedGroupForm = Form.create()(GroupForm);

export default WrappedGroupForm;
